import React from 'react';
import { useGlobalDataContext } from '../../../contexts/GlobalData/GlobalDataContext';
import { useLoading } from '@context/Loading/LoadingContext';
import { defaultConfig, searchStates } from '@config';

const Reset = ({ setData }) => {
    // eslint-disable-next-line no-unused-vars
    const { setGlobalContext } = useGlobalDataContext();
    const { setLoading } = useLoading();

    const handleClick = () => {
        setLoading(true);
        setData({});

        setGlobalContext(({ searchState }) => ({
            ...defaultConfig,
            searchState: searchStates.UPDATING,
            prevSearchState: searchState
        }));
    };

    return (
        <>
            <span onClick={() => handleClick()}>Alles wissen</span>
        </>
    );
};

export default Reset;
